import flatten from 'lodash/flatten'
import map from 'lodash/map'
import {ajaxJsonCall} from '@freckle/ajax'
import {fromJust} from '@freckle/maybe'
import CApiHelper from '@freckle/educator-entities/ts/common/helpers/common-api-helper'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {RlSkillUspIdT} from '@freckle/educator-entities/ts/common/types/rl-skill-usp-id'
import {RlStandardIdT} from '@freckle/educator-entities/ts/common/types/rl-standard-id'
import {
  GrammarQuestionT,
  GrammarQuestionShellT,
  parseGrammarQuestion,
  parseGrammarQuestionShells,
} from '@freckle/educator-entities/ts/ela/common/models/grammar-question'

function parseGrammarQuestions(response: unknown[]): Array<GrammarQuestionT> {
  return map(response, parseGrammarQuestion)
}

export function fetchGrammarQuestion(questionUuid: string): Promise<GrammarQuestionT> {
  return ajaxJsonCall({
    url: `${PATHS.textAssetsUrl}/ela/grammar-questions/${questionUuid}.json`,
    method: 'GET',
  }).then(response =>
    fromJust(
      parseGrammarQuestions(response as unknown[])[0],
      `Grammar question ${questionUuid} does not exist`
    )
  )
}

type ResponseT = {questions: Array<GrammarQuestionShellT>}[]

export async function fetchArbitraryGrammarQuestionShells(
  targetSkillId: RlSkillUspIdT | null,
  targetStandardId: RlStandardIdT | null,
  elaStandardSetId: string,
  numQuestions: number,
  isWritingDomain: boolean,
  excludedQuestions: string[] = []
): Promise<Array<GrammarQuestionShellT>> {
  const response: ResponseT = await ajaxJsonCall({
    url: CApiHelper.fancyPaths.v3.content_area.content_area_questions.arbitrary('ela'),
    method: 'POST',
    data: JSON.stringify({
      targetSkillId,
      targetStandardId,
      standardSetId: elaStandardSetId,
      numQuestions,
      excludedQuestions,
      isWritingDomain,
    }),
  })
  const questions = flatten(response.map(r => r.questions))
  return parseGrammarQuestionShells(questions)
}
